module.exports = __webpack_public_path__ + "img/trash.2964a0ca.png";